import React, { useState } from 'react';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Link from '@amzn/meridian/link';
import { useTranslation } from 'src/arb-wrapper';

interface ReasoningToggleProps {
  text: string;
}

export const ReasoningToggle: React.FC<ReasoningToggleProps> = ({ text }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  if (!text.trim()) return null;
  return (
    <Column spacing="xs">
      <Link type="secondary" onClick={() => { setOpen(!open); }}>
        <Text color="secondary" type="b100">{open ? `▾ ${t('chat_hide_reasoning')}` : `▸ ${t('chat_show_reasoning')}`}</Text>
      </Link>
      {open && (
        <Text color="secondary" tag="div" type="b100">
          <span style={{ fontStyle: 'italic', whiteSpace: 'pre-wrap' }}>{text}</span>
        </Text>
      )}
    </Column>
  );
};
